import React, { useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";

import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import stlyes from "./ModalsResponsiveFullScreen.module.css";

function ModalsResponsiveFullScreen(props) {
  const [open, setOpen] = React.useState(false);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div className={stlyes.MdlResponsiveFullScreen}>
      <Dialog
        fullScreen={fullScreen}
        open={props.open}
        onClose={props.handleClose}
        aria-labelledby="responsive-dialog-title"
        className={stlyes.MdFullScreenContainer}
      
        PaperProps={{
          style: { width: props.width, },
        }}
      >
        <div
          className={stlyes.ModaFulllTitle}
          style={{ color: props.Headercolor, padding:props.padding, justifyContent:props.textAlign }}
        >
          {props.ModalTitle}
          <span className={stlyes.ModaCloseIcon}>
            <CloseRoundedIcon
              className={stlyes.ModaClose}
              onClick={() => props.handleClose()}
              style={{ color: props.Headercolor }}
            />
          </span>
        </div>
      
        <DialogContent className={stlyes.ModalBody} style={{paddingTop:props.BodyPaddingTop,  }}>{props.body}</DialogContent>

        {props.ModalFooter && (
          <div style={{ background: props.Footerbackground }}>
            <div className={stlyes.FooterButtonContainer}>
              <Button
                variant="contained"
                className={stlyes.btLight}
                onClick={() => props.handleClose()}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                className={stlyes.btnBlue}
                onClick={() => props.handleConfirm()}
              >
                {props.ButtonConfirm}
              </Button>
            </div>
          </div>
        )}
      </Dialog>
    </div>
  );
}

export default ModalsResponsiveFullScreen;
